import { post } from "@utils/fetch";

type AuthenticateOrganizationInput = {
  token: string;
  stytchOrganizationId: string;
};

type AuthenticateOrganizationResponse = {
  data: string;
};

export const authenticateOrganization = async (
  input: AuthenticateOrganizationInput,
): Promise<AuthenticateOrganizationResponse> => {
  const { data } = await post(
    "/api/public/v1/auth/authenticate-organization/",
    input,
  );

  return data;
};
